// extracted by mini-css-extract-plugin
export var dividerContainer = "_8f-0";
export var line = "_8f-1";